import React, { createContext } from 'react';

type MarkdownRenderer = React.ComponentType<{ content: string }>;

const PlainTextRenderer: MarkdownRenderer = ({ content }) => <div className="whitespace-pre-wrap">{content}</div>;

// The display already imports the citation link, so what renders inside a citation takes the display
// from here instead of importing it back.
export const MarkdownRendererContext = createContext<MarkdownRenderer>(PlainTextRenderer);
